import React, { useState, useEffect } from "react"
import axios from "axios"
import { Row, Col, Modal, Spinner } from "reactstrap"
import {
  AvForm,
  AvField,
  AvRadio,
  AvRadioGroup,
  AvCheckbox,
  AvCheckboxGroup,
} from "availity-reactstrap-validation"
import { getCurrentUser, getPermission } from "../../helpers/Utils"
import { toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import PhoneInput from "react-phone-input-2"
import "react-phone-input-2/lib/style.css"
import { useFormik } from "formik"
import csc from "country-state-city"
import Select from "react-select"
import moment from "moment"
import DatePicker from "react-datepicker"
import CreateFollowup from "../Create-Followup"
import ReactQuill from "react-quill"
import "react-quill/dist/quill.snow.css"

const TOAST_CONFIG = {
  position: "top-center",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
}

const API_TIMEOUT_MS = 120000

const getApiUrl = endpoint => {
  const companyName = localStorage.getItem("company_name")
  return `${process.env.REACT_APP_API_URL}/${companyName}/${endpoint}`
}

const getAuthHeaders = () => ({
  headers: {
    "content-type": "application/json",
    Authorization: `Bearer ${getCurrentUser()?.token || ""}`,
  },
})

const mergeFieldIntoValues = (fieldArray, targetArray) => {
  fieldArray.forEach(item => {
    const index = targetArray.findIndex(
      fv => fv.lead_field_id === item.lead_field_id
    )
    if (index !== -1) {
      targetArray[index].value = item.value
    } else {
      targetArray.push(item)
    }
  })
}

let selectedUserId = []
let phoneNumber = ""
let countryCode = ""
let altCountryCode = ""
let updatedStates = []
let fieldValues = []
let fieldCheckbox = []
let fieldText = []
let fieldTextArea = []
let fieldSelect = []
let fieldRadio = []
let fieldFlipButton = []

export default function EditLeadModal(props) {
  // Permission checking logic
  const currentUser = getCurrentUser()
  const isAdmin = currentUser?.role_name === "Administrator"
  const permissions = getPermission()

  // Get module context from props or try to infer from URL/caller
  const moduleContext = props.module || props.context || inferModuleContext()

  function inferModuleContext() {
    // Try to infer context from window location or other indicators
    const pathname = window.location.pathname

    if (
      pathname.includes("followup") ||
      pathname.includes("today") ||
      pathname.includes("future")
    )
      return "followup"
    if (pathname.includes("customer")) return "customer"
    if (pathname.includes("my-lead")) return "my_lead"
    if (pathname.includes("repeated-lead") || pathname.includes("duplicated"))
      return "repeated_lead"
    if (pathname.includes("company-pool")) return "company_pool"
    if (pathname.includes("winback-pool")) return "winback_pool"
    if (pathname.includes("dead-lead") || pathname.includes("dead"))
      return "dead_lead"
    if (pathname.includes("transfer")) return "general_lead"

    // Default fallback
    return "general_lead"
  }

  // Check if user has edit permission for leads based on context
  const hasEditPermission = () => {
    try {
      let hasPermission = false
      switch (moduleContext) {
        case "lead":
          hasPermission = permissions?.lead?.lead?.edit?.is_checked === "yes"
          break
        case "today_followup":
          hasPermission =
            permissions?.today_followup?.today_followup?.edit?.is_checked ===
            "yes"
          break
        case "future_followup":
          hasPermission =
            permissions?.future_followup?.future_followup?.edit?.is_checked ===
            "yes"
          break

        case "customer":
          hasPermission =
            permissions?.customer?.customer?.edit?.is_checked === "yes"
          break

        case "my_lead":
          hasPermission =
            permissions?.my_lead?.my_lead?.edit?.is_checked === "yes"
          break

        case "repeated_lead":
          hasPermission =
            permissions?.repeated_lead?.repeated_lead?.edit?.is_checked ===
            "yes"
          break

        case "company_pool":
          hasPermission =
            permissions?.company_pool?.company_pool?.edit?.is_checked === "yes"
          break

        case "winback_pool":
          hasPermission =
            permissions?.winback_pool?.winback_pool?.edit?.is_checked === "yes"
          break

        case "dead_lead":
          hasPermission =
            permissions?.dead_lead?.dead_lead?.edit?.is_checked === "yes" ||
            permissions?.dead_request_lead?.dead_request_lead?.edit
              ?.is_checked === "yes"
          break
        case "repeated_lead":
          hasPermission =
            permissions?.repeated_lead?.repeated_lead?.edit?.is_checked ===
            "yes"
          break
        case "company_pool":
          hasPermission =
            permissions?.company_pool?.company_pool?.edit?.is_checked === "yes"
          break
        case "winback_pool":
          hasPermission =
            permissions?.winback_pool?.winback_pool?.edit?.is_checked === "yes"
          break
        default:
          // Check any lead permission as fallback
          hasPermission =
            permissions?.my_lead?.my_lead?.edit?.is_checked === "yes" ||
            permissions?.repeated_lead?.repeated_lead?.edit?.is_checked ===
              "yes" ||
            permissions?.company_pool?.company_pool?.edit?.is_checked ===
              "yes" ||
            permissions?.winback_pool?.winback_pool?.edit?.is_checked === "yes"
          break
      }

      return hasPermission
    } catch (error) {
      return false
    }
  }

  // Helper function to check if field can be edited
  const canEditField = (fieldName, existingValue) => {
    // Admin can always edit
    if (isAdmin) return true

    // If user HAS edit permission, they can edit everything
    if (hasEditPermission()) return true

    // If user doesn't have edit permission, check if field is empty
    // They can only add values to empty fields, not modify existing ones
    const valueStr = String(existingValue || "").trim()

    // If field has existing value (not null/empty/undefined), user can't modify it
    if (valueStr && valueStr !== "null" && valueStr !== "undefined") {
      return false
    }

    // Field is empty, allow adding value
    return true
  }

  const [lead, setLead] = useState([])
  const [loading, setLoading] = useState(false)
  const [loader1, setLoader1] = useState(false)
  const [bigModal, setBigModal] = useState(false)
  const [modal, setModal] = useState(false)
  const [error, setError] = useState("")
  const [newsletter, setNewsletter] = useState(false)
  const [flip_button, setFlip_button] = useState(false)
  const [indiaOnly, setIndiaOnly] = useState(true)
  const [indiaOnlyalt, setIndiaOnlyalt] = useState(true)
  const [allFields, setAllFields] = useState([])
  const [timer, setTimer] = useState(null)
  const [districtMessage, setDistrictMessage] = useState("")
  const [emailMessage, setEmailMessage] = useState("")
  const [NumberMessage, setNumberMessage] = useState("")
  const [alternateNumber, setAlternateNumber] = useState("")
  const [duplicate, setDuplicate] = useState(0)
  const [duplicate2, setDuplicate2] = useState(0)
  const [duplicate3, setDuplicate3] = useState(1)
  const [sortName, setSortName] = useState("in")
  const [altsortName, setAltSortName] = useState("in")
  const [country, setCountry] = useState(props.lead && props.lead.country_name)
  const [state, setState] = useState(props.lead && props.lead.state)
  const [district, setDistrict] = useState(props.lead && props.lead.district)
  const [city, setCity] = useState(props.lead && props.lead.city)
  const [area, setArea] = useState(props.lead && props.lead.working_area)
  const [message, setMessage] = useState("")
  const [proformaValue, setProformaValue] = useState(
    props.lead && props.lead.proforma_address
  )
  const [deliverTo, setDeliverTo] = useState(
    props.lead && props.lead.deliver_to
  )
  const [dobDate, setDobDate] = useState()
  const [anniDate, setAnniDate] = useState()
  const [importantDate, setImportantDate] = useState()
  const [branches, setBranches] = useState([])
  const [selectedBranches, setSelectedBranches] = useState(
    props.lead?.branch ? [props.lead.branch.name] : []
  )
  const [dashboardData, setDashboardData] = useState(null)
  const [filteredLeadHolders, setFilteredLeadHolders] = useState([])
  const [branchManagers, setBranchManagers] = useState([])
  const [selectedLabels, setSelectedLabels] = useState(
    props.lead?.lead_label?.map(item => ({
      value: item.id,
      label: item.name,
    })) || []
  )
  const [altNumber, setAltNumber] = useState("")

  useEffect(() => {
    if (props.lead) {
      setAltNumber(props.lead?.alternate_number || "")
    }
  }, [props.lead])

  useEffect(() => {
    const storedData = localStorage.getItem("DashboardData")
    if (storedData) {
      const parsedData = JSON.parse(storedData)
      setDashboardData(parsedData)
      setBranchManagers(parsedData.branch_managers || [])
    }
  }, [])
  useEffect(() => {
    const newBranch = localStorage.getItem("showBranch")
    if (newBranch) {
      const parsedBranches = JSON.parse(newBranch)
      const formattedBranches = parsedBranches.map(item => ({
        value: item.id,
        label: item.name,
      }))

      setBranches(formattedBranches)
    }
  }, [])

  const addressFromik = useFormik({
    initialValues: {
      country: "India",
      state: null,
      city: null,
      area: null,
    },
    onSubmit: values => {},
  })

  const countries = csc.getAllCountries()

  const updatedCountries = countries.map(country => ({
    label: country.name,
    value: country.id,
    ...country,
  }))

  const updatedState = e => {
    if (e !== undefined) {
      updatedStates = csc
        .getStatesOfCountry(e)
        .map(state => ({ label: state.name, value: state.id, ...state }))
    } else {
      updatedStates = csc
        .getStatesOfCountry("101")
        .map(state => ({ label: state.name, value: state.id, ...state }))
    }
  }

  const updatedCities = stateId =>
    csc
      .getCitiesOfState(stateId)
      .map(city => ({ label: city.name, value: city.id, ...city }))

  const { values, handleSubmit, setFieldValue, setValues } = addressFromik

  useEffect(() => {}, [values])

  const getAllFields = () => {
    fieldValues = []
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/lead-field${
          props.lead !== undefined ? `?lead_id=${props.lead.id}` : ""
        }`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${
              getCurrentUser().token == null ? "" : getCurrentUser().token
            }`,
          },
        }
      )
      .then(function (res) {
        if (res.data.status) {
          setError(res.data.message)
          setAllFields(res.data.data)
          res.data.data?.map(item => {
            fieldValues.push({
              lead_field_id: item.id,
              value: item.value !== null ? item.value : "",
            })
          })
        } else {
          setError(res.data.message)
        }
        if (props.setLoader3) {
          props.setLoader3(false)
        }
      })
  }

  const dialCode = e => {
    let str = e
    let str2 = str.toLowerCase()
    setSortName(str2)
    if (e == "IN") {
      setIndiaOnly(true)
    } else {
      setIndiaOnly(false)
    }
  }
  const altdialCode = e => {
    let str = e
    let str2 = str.toLowerCase()
    setAltSortName(str2)
    if (e == "IN") {
      setIndiaOnlyalt(true)
    } else {
      setIndiaOnlyalt(false)
    }
  }

  const getAllStates = e => {
    setState("")
    setDistrict("")
    setCity("")
    if (e.length == 6) {
      setLoader1(true)
      axios
        .get(`${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/pincode/${e}`, {
          headers: {
            "content-type": "application/json",
          },
        })
        .then(function (res) {
          if (res.data.status === true) {
            const location = res.data.data;
            setDistrict(location.district)
            setState(location.state)
            setCity(location.city) // Set city to Block from API
            setMessage("")
            setValues(
              {
                country: 'India',
                state: location.state,
                city: location.city,
              },
              false
            )
            setFieldValue("state", location.state)
            districtExist(location.district)
            setLoader1(false)
          } else {
            
            setMessage(res.data.message)
            setLoader1(false)
          }
        })
    }
  }

  const getLeadEmail = e => {
    clearTimeout(timer)
    const newTimer = setTimeout(() => {
      emailExist(e)
    }, 1000)
    setTimer(newTimer)
  }

  const emailExist = e => {
    setDuplicate(0)
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/lead-exist?type=email&value=${e}`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${
              getCurrentUser().token == null ? "" : getCurrentUser().token
            }`,
          },
        }
      )
      .then(function (res) {
        if (res.data.status) {
          setEmailMessage(res.data.message)
          if (res.data == "") {
            setDuplicate(1)
            setEmailMessage("")
          } else {
            setDuplicate(res.data.duplicate)
          }
        } else {
          setEmailMessage("")
        }
      })
  }

  const numberExist = e => {
    if (e.length > 10) {
      setDuplicate2(0)
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
            "company_name"
          )}/lead-exist?type=number&value=${e}`,
          {
            headers: {
              "content-type": "application/json",
              Authorization: `Bearer ${
                getCurrentUser().token == null ? "" : getCurrentUser().token
              }`,
            },
          }
        )
        .then(function (res) {
          if (res.data.status) {
            setNumberMessage(res.data.message)
            setDuplicate2(res.data.duplicate)
          } else {
            setDuplicate2(1)
            setNumberMessage("")
          }
        })
    }
  }

  const alternateNumberExist = e => {
    if (e.length > 9) {
      setDuplicate3(1)
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
            "company_name"
          )}/lead-exist?type=alternate_number&value=${e}`,
          {
            headers: {
              "content-type": "application/json",
              Authorization: `Bearer ${
                getCurrentUser().token == null ? "" : getCurrentUser().token
              }`,
            },
          }
        )
        .then(function (res) {
          if (res.data.status) {
            setAlternateNumber(res.data.message)
            setDuplicate3(res.data.duplicate)
          } else {
            setDuplicate3(1)
            setAlternateNumber("")
          }
        })
    }
  }

  const getphonee = (a, b, c, d) => {
    countryCode = b.dialCode
    if (b.dialCode != "91") {
      setDuplicate2(1)
      setIndiaOnly(false)
    } else {
      setIndiaOnly(true)
    }
    let str = d
    const after = str.slice(str.indexOf(" ") + 1)
    phoneNumber = after
    setTimeout(() => {
      numberExist(after)
    }, 500)
  }

  const getalterphonee = (a, b, c, d) => {
    altCountryCode = b.dialCode
    if (b.dialCode != "91") {
      setDuplicate3(1)
      setIndiaOnlyalt(false)
    } else {
      setIndiaOnlyalt(true)
    }
    let str = d
    const after = str.slice(str.indexOf(" ") + 1)
    if (after === "" || /^\+?[0-9]*$/.test(after)) {
      setAltNumber("")
    } else {
      setAltNumber(after)
    }
    setTimeout(() => {
      alternateNumberExist(after)
    }, 500)
  }

  const districtExist = e => {
    setDistrictMessage("")
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/district-exist?district=${e}`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${
              getCurrentUser().token == null ? "" : getCurrentUser().token
            }`,
          },
        }
      )
      .then(function (res) {
        if (res.data.status) {
          setDistrictMessage(res.data.data)
        } else {
          setDistrictMessage("")
        }
      })
  }

  const checkImportantDate = () => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/check-important-date-field`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${
              getCurrentUser().token == null ? "" : getCurrentUser().token
            }`,
          },
        }
      )
      .then(function (res) {
        if (res.data.status) {
          localStorage.setItem(
            "ShowImportant",
            res.data.data?.show_important_date
              ? res.data.data?.show_important_date
              : ""
          )
        } else {
          localStorage.setItem("ShowImportant", "")
        }
      })
  }

  const setAllFieldValues = (e, id) => {
    if (e.target && e.target.type !== undefined) {
      if (e.target.type === "checkbox" && e.target.role === null) {
        if (e.target.checked === true) {
          let index = fieldCheckbox.findIndex(
            fieldCheckbox => fieldCheckbox.lead_field_id === id
          )
          if (index !== -1) {
            var oldValue = fieldCheckbox[index].value
            fieldCheckbox[index].value = oldValue
              ? oldValue + "," + e.target.value
              : e.target.value
          } else {
            fieldCheckbox.push({ lead_field_id: id, value: e.target.value })
          }
        } else {
          let index = fieldCheckbox.findIndex(
            fieldCheckbox => fieldCheckbox.lead_field_id === id
          )
          if (index !== -1) {
            var oldValue = fieldCheckbox[index].value
            oldValue = oldValue.split(",")
            let index2 = oldValue.indexOf(e.target.value)
            if (index2 !== -1) {
              oldValue.splice(index2, 1)
            }
            oldValue = oldValue.join()
            fieldCheckbox[index].value = oldValue
          }
        }
      } else if (e.target.type === "text") {
        let index = fieldText.findIndex(
          fieldText => fieldText.lead_field_id === id
        )
        if (index !== -1) {
          fieldText[index].value = e.target.value
        } else {
          fieldText.push({ lead_field_id: id, value: e.target.value })
        }
      } else if (e.target.type === "textarea") {
        let index = fieldTextArea.findIndex(
          fieldTextArea => fieldTextArea.lead_field_id === id
        )
        if (index !== -1) {
          fieldTextArea[index].value = e.target.value
        } else {
          fieldTextArea.push({ lead_field_id: id, value: e.target.value })
        }
      } else if (e.target.type === "radio") {
        let index = fieldRadio.findIndex(
          fieldRadio => fieldRadio.lead_field_id === id
        )
        if (index !== -1) {
          fieldRadio[index].value = e.target.value
        } else {
          fieldRadio.push({ lead_field_id: id, value: e.target.value })
        }
      } else if (e.target.type === "select-one") {
        let index = fieldSelect.findIndex(
          fieldSelect => fieldSelect.lead_field_id === id
        )
        if (index !== -1) {
          fieldSelect[index].value = e.target.value
        } else {
          fieldSelect.push({ lead_field_id: id, value: e.target.value })
        }
      } else if (e.target.role === "switch") {
        let index = fieldFlipButton.findIndex(
          fieldFlipButton => fieldFlipButton.lead_field_id === id
        )
        if (index !== -1) {
          fieldFlipButton[index].value = e.target.checked ? "on" : "off"
        } else {
          fieldFlipButton.push({
            lead_field_id: id,
            value: e.target.checked ? "on" : "off",
          })
        }
      }
    } else {
    }
  }

  const options = []

  if (JSON.parse(localStorage.getItem("AllLabels"))) {
    JSON.parse(localStorage.getItem("AllLabels")).map(item => {
      options.push({
        value: item.id,
        label: item.name,
      })
    })
  }

  const dValues = []

  const handleSelectChange = selectedOptions => {
    const selectedIds = selectedOptions
      ? selectedOptions.map(option => option.value)
      : []
    setSelectedBranches(selectedIds)

    const filteredManagers =
      selectedIds.length > 0
        ? dashboardData?.branch_managers.filter(manager =>
            selectedIds.includes(manager.branch_id)
          )
        : []

    setFilteredLeadHolders(filteredManagers || []) // Use managers directly
  }

  const handleSelectChanges = e => {
    const selectedValue = parseInt(e.target.selectedOptions[0]?.value, 10)
    setSelectedBranches(selectedValue)
  }

  const getSelectedId = selectedOptions => {
    setSelectedLabels(selectedOptions || [])
  }

  const submitLead = (e, value) => {
    let flagValue = "0"
    let whatsapp = 0
    let sendEmail = 0
    if (e.target.flag.checked) {
      flagValue = "1"
    } else {
      flagValue = "0"
    }
    fieldCheckbox.map(item => {
      let index = fieldValues.findIndex(
        fieldValues => fieldValues.lead_field_id === item.lead_field_id
      )
      if (index !== -1) {
        fieldValues[index].value = item.value
      } else {
        fieldValues.push(item)
      }
    })
    fieldText.map(item => {
      let index = fieldValues.findIndex(
        fieldValues => fieldValues.lead_field_id === item.lead_field_id
      )
      if (index !== -1) {
        fieldValues[index].value = item.value
      } else {
        fieldValues.push(item)
      }
    })
    fieldTextArea.map(item => {
      let index = fieldValues.findIndex(
        fieldValues => fieldValues.lead_field_id === item.lead_field_id
      )
      if (index !== -1) {
        fieldValues[index].value = item.value
      } else {
        fieldValues.push(item)
      }
    })
    fieldRadio.map(item => {
      let index = fieldValues.findIndex(
        fieldValues => fieldValues.lead_field_id === item.lead_field_id
      )
      if (index !== -1) {
        fieldValues[index].value = item.value
      } else {
        fieldValues.push(item)
      }
    })
    fieldSelect.map(item => {
      let index = fieldValues.findIndex(
        fieldValues => fieldValues.lead_field_id === item.lead_field_id
      )
      if (index !== -1) {
        fieldValues[index].value = item.value
      } else {
        fieldValues.push(item)
      }
    })
    fieldFlipButton.map(item => {
      let index = fieldValues.findIndex(
        fieldValues => fieldValues.lead_field_id === item.lead_field_id
      )
      if (index !== -1) {
        fieldValues[index].value = item.value
      } else {
        fieldValues.push(item)
      }
    })
    let tagID = ""
    if (e.target.tag_id !== undefined) {
      tagID = e.target.tag_id.value
    }
    setLoading(true)
    const api = axios.create()
    const CancelToken = axios.CancelToken
    const source = CancelToken.source()

    api.interceptors.request.use(config => {
      config.cancelToken = source.token
      return config
    })

    const timeout = 120000 // 2 minute

    setTimeout(() => {
      source.cancel("Timeout")
    }, timeout)

    if (props.lead !== undefined) {
      if (phoneNumber == "") {
        phoneNumber = props.lead && props.lead.number
      }
      if (altNumber == "" && altNumber == null) {
        altNumber = props.lead?.alternate_number || ""
      }
      if (countryCode == "") {
        countryCode = props.lead?.country_code ? props.lead?.country_code : ""
      } else {
        if (countryCode?.includes("+")) {
        } else {
          countryCode = `+ ${countryCode}`
        }
      }
      if (altCountryCode == "") {
        altCountryCode = props.lead?.alternate_country_code
          ? props.lead?.alternate_country_code
          : ""
      } else {
        if (altCountryCode?.includes("+")) {
        } else {
          altCountryCode = `+ ${altCountryCode}`
        }
      }
      axios
        .put(
          `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
            "company_name"
          )}/lead/${props.lead.id}`,
          {
            name: e.target.name.value,
            email: e.target.email.value,
            firm_name: e.target.firm_name.value,
            number: phoneNumber,
            alternate_number: altNumber,
            alternate_country_code: altCountryCode,
            leadholder_id: e.target.leadholder_id.value,
            lead_source_id: e.target.lead_source_id.value,
            country_name: country,
            state: state,
            district: district,
            working_area: area,
            country_code: countryCode,
            dob: e.target.dob.value,
            best_time: e.target.best_time.value,
            anniversary: e.target.anniversary.value,
            important_date: e.target.important_date.value,
            city: e.target.city.value,
            pin_code: e.target.pin_code.value,
            monthly_target:
              e.target.monthly_target !== undefined
                ? e.target.monthly_target.value
                : "",
            tag_id: tagID,
            flag: flagValue,
            lead_label_id: selectedLabels.map(item => item.value),
            proforma_address: proformaValue,
            deliver_to: deliverTo,
            fieldvalues: fieldValues,
            branch_id: selectedBranches,
          },
          {
            headers: {
              Authorization: `Bearer ${
                getCurrentUser().token == null ? "" : getCurrentUser().token
              }`,
            },
          }
        )
        .then(function (res) {
          if (res.data.status) {
            setLoading(false)
            fieldValues = []
            if (props.setIsOpen) {
              props.setIsOpen(false)
            }
            props.setLead(res.data.data)
            props.setmodal_standard(false)
            toast.success(res.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            })
            setDistrictMessage("")
            setEmailMessage("")
            setNumberMessage("")
            setAlternateNumber("")
            if (!localStorage.getItem("ShowImportant")) {
              checkImportantDate()
            }
            // Force refresh data if getAllLeads function is provided
            if (props.getAllLeads !== undefined) {
              //props.getAllLeads("refresh")
            }
            const updatedLead = res.data.data
            const storedLeads =
              JSON.parse(localStorage.getItem("All-Leads-Data")) || []
            const storedLeadsFollowup =
              JSON.parse(localStorage.getItem("All-Followup-Data")) || []

            const updatedLeads = storedLeads.map(lead =>
              lead.id === updatedLead.id ? { ...lead, ...updatedLead } : lead
            )
            const updatedLeadsFollowup = storedLeadsFollowup.map(lead =>
              lead.id === updatedLead.id ? { ...lead, ...updatedLead } : lead
            )

            localStorage.setItem("All-Leads-Data", JSON.stringify(updatedLeads))
            localStorage.setItem(
              "All-Followup-Data",
              JSON.stringify(updatedLeadsFollowup)
            )
          } else {
            setLoading(false)
            toast.error(res.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            })
            setDistrictMessage("")
            setEmailMessage("")
            setNumberMessage("")
            setAlternateNumber("")
          }
        })
    } else {
      if (e.target.whatsapp.checked) {
        whatsapp = 1
      } else {
        whatsapp = 0
      }
      if (e.target.send_email.checked) {
        sendEmail = 1
      } else {
        sendEmail = 0
      }
      axios
        .post(
          `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
            "company_name"
          )}/lead`,
          {
            name: e.target.name.value,
            email: e.target.email.value,
            firm_name: e.target.firm_name.value,
            number: phoneNumber,
            alternate_number: altNumber,
            alternate_country_code: altCountryCode,
            type: "new",
            leadholder_id: e.target.leadholder_id.value,
            lead_source_id: e.target.lead_source_id.value,
            country_name: country,
            state: state,
            district: district,
            working_area: area,
            country_code: `+ ${countryCode}`,
            dob: e.target.dob.value,
            best_time: e.target.best_time.value,
            anniversary: e.target.anniversary.value,
            important_date: e.target.important_date.value,
            city: e.target.city.value,
            pin_code: e.target.pin_code.value,
            tag_id: tagID,
            flag: flagValue,
            whatsapp: whatsapp,
            send_email: sendEmail,
            message: e.target.message.value,
            lead_label_id: selectedLabels.map(item => item.value),
            proforma_address: proformaValue,
            deliver_to: deliverTo,
            fieldvalues: fieldValues,
            branch_id: selectedBranches,
          },
          {
            headers: {
              Authorization: `Bearer ${
                getCurrentUser().token == null ? "" : getCurrentUser().token
              }`,
            },
          }
        )
        .then(function (res) {
          if (res.data.status) {
            setLoading(false)
            setLead(res.data.data)
            if (props.getAllLeads !== undefined) {
              if (props.local !== undefined) {
                props.getAllLeads(undefined, "refresh")
              } else {
                props.getAllLeads()
              }
            }
            fieldValues = []
            toast.success(res.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            })
            setDistrictMessage("")
            setEmailMessage("")
            setNumberMessage("")
            setAlternateNumber("")
            if (!localStorage.getItem("ShowImportant")) {
              checkImportantDate()
            }
            setTimeout(() => {
              setModal(true)
            }, 1500)
          } else {
            setLoading(false)
            toast.error(res.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            })
            setDistrictMessage("")
            setEmailMessage("")
            setNumberMessage("")
            setAlternateNumber("")
          }
        })
    }
  }

  useEffect(() => {
    const close = e => {
      if (e.key === "Escape") {
        props.setmodal_standard(false)
        setDistrictMessage("")
        setEmailMessage("")
        setNumberMessage("")
        setAlternateNumber("")
      }
    }
    window.addEventListener("keydown", close)
    return () => window.removeEventListener("keydown", close)
  }, [])

  useEffect(() => {
    updatedState()
    getAllFields()
    fieldValues = []
    phoneNumber = ""
    countryCode = ""
    if (props.lead !== undefined) {
      const momentDate = moment(props.lead.dob, "DD-MM-YYYY")
      const annDate = moment(props.lead.anniversary, "DD-MM-YYYY")
      const impDate = moment(
        props.lead?.important_date,
        ["YYYY-MM-DD", "DD-MM-YYYY"],
        true
      )
      if (momentDate.isValid()) {
        setDobDate(momentDate.toDate())
      }
      if (annDate.isValid()) {
        setAnniDate(annDate.toDate())
      }
      if (impDate.isValid()) {
        setImportantDate(impDate.toDate())
      }
    }
    if (props.lead && props.lead.lead_label !== null) {
      selectedUserId = []
      props.lead &&
        props.lead.lead_label.map(item => {
          dValues.push({
            value: item.id,
            label: item.name,
          })
          selectedUserId.push(item.id)
        })
    } else {
      ;("")
    }
  }, [])

  return (
    <>
      {modal ? (
        <CreateFollowup
          modal={modal}
          setModal={setModal}
          lead={lead}
          customActiveTab={2}
          getAllLeads={props.getAllLeads}
          local={props.local}
          setmodal_standard={props.setmodal_standard}
        />
      ) : null}
      {props.loader3 ? (
        ""
      ) : (
        <Modal isOpen={props.modal_standard} centered={true} size="xl">
          <AvForm
            className="mt-0"
            id="myModalLabel"
            onSubmit={(e, v) => submitLead(e, v)}
          >
            <div className="modal-header">
              <h5 className="modal-title mt-0" id="myLargeModalLabel">
                {props.lead !== undefined ? "Edit info" : "Create lead"}
              </h5>
              <button
                className="cross__btn"
                onClick={() => {
                  props.setmodal_standard(false)
                  setDistrictMessage(""),
                    setEmailMessage(""),
                    setNumberMessage(""),
                    setAlternateNumber("")
                  if (props.setLoader3) {
                    props.setLoader3(false)
                  }
                }}
                aria-hidden="true"
                type="button"
              >
                &times;
              </button>
            </div>
            <div className="modal-body">
              {!isAdmin && !hasEditPermission() && (
                <div className="alert alert-warning mb-3">
                  <i className="fas fa-exclamation-triangle me-2"></i>
                  <strong>Note:</strong> You can add new information to empty
                  fields, but cannot modify existing data. Only administrators
                  can edit existing information.
                </div>
              )}
              {emailMessage ? (
                <p
                  className="alert alert-message d-table text-center w-100"
                  dangerouslySetInnerHTML={{ __html: emailMessage }}
                />
              ) : (
                ""
              )}
              {NumberMessage ? (
                <p
                  className="alert alert-message d-table text-center w-100 bg-danger text-white"
                  dangerouslySetInnerHTML={{ __html: NumberMessage }}
                />
              ) : (
                ""
              )}
              {alternateNumber ? (
                <p
                  className="alert alert-message d-table text-center w-100 bg-danger text-white"
                  dangerouslySetInnerHTML={{ __html: alternateNumber }}
                />
              ) : (
                ""
              )}
              {districtMessage ? (
                <p
                  className="alert alert-message d-table text-center w-100"
                  dangerouslySetInnerHTML={{ __html: districtMessage }}
                />
              ) : (
                ""
              )}
              <Row>
                <Col md={3}>
                  <div className="mb-3 required">
                    <AvField
                      label="Lead Name"
                      className={
                        canEditField("name", props.lead?.name)
                          ? ""
                          : "disable-field"
                      }
                      type="text"
                      name="name"
                      placeholder="Enter name"
                      value={props.lead && props.lead.name}
                      disabled={!canEditField("name", props.lead?.name)}
                      readOnly={
                        isAdmin
                          ? false
                          : props.lead !== undefined &&
                            localStorage.getItem("company_name") === "defence"
                          ? true
                          : false
                      }
                    />
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-3">
                    <AvField
                      label="Email"
                      className={
                        canEditField("email", props.lead?.email)
                          ? ""
                          : "disable-field"
                      }
                      type="email"
                      name="email"
                      placeholder="Enter email address"
                      onChange={e => getLeadEmail(e.target.value)}
                      value={props.lead && props.lead.email}
                      disabled={!canEditField("email", props.lead?.email)}
                      readOnly={
                        isAdmin
                          ? false
                          : props.lead !== undefined &&
                            localStorage.getItem("company_name") === "defence"
                          ? true
                          : false
                      }
                    />
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-3 required">
                    <label className="">Phone/Whatsapp Number</label>
                    <PhoneInput
                      country={sortName}
                      className={
                        canEditField("number", props.lead?.number)
                          ? ""
                          : "disable-field"
                      }
                      onChange={(s, d, f, g) => getphonee(s, d, f, g)}
                      placeholder="Enter number"
                      value={`${
                        props.lead && props.lead.country_code !== null
                          ? props.lead.country_code
                          : "91"
                      } ${props.lead && props.lead.number}`}
                      name="number"
                      inputStyle={{ width: "100%" }}
                      disabled={!canEditField("number", props.lead?.number)}
                      readOnly={
                        isAdmin
                          ? false
                          : props.lead !== undefined &&
                            localStorage.getItem("company_name") === "defence"
                          ? true
                          : false
                      }
                    />
                    {indiaOnly ? (
                      <p className="text-normal fst-italic">
                        (Only 10 digits required)
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-3">
                    <label className="">Alternate Number</label>
                    <PhoneInput
                      country={altsortName}
                      className={
                        canEditField(
                          "alternate_number",
                          props.lead?.alternate_number
                        )
                          ? ""
                          : "disable-field"
                      }
                      onChange={(s, d, f, g) => getalterphonee(s, d, f, g)}
                      placeholder="Enter number"
                      value={`${
                        props.lead && props.lead.alternate_country_code !== null
                          ? props.lead.alternate_country_code
                          : "91"
                      } ${props.lead && props.lead.alternate_number}`}
                      name="alternate_number"
                      inputStyle={{ width: "100%" }}
                      onFocus={e =>
                        e.target.addEventListener(
                          "wheel",
                          function (e) {
                            e.preventDefault()
                          },
                          { passive: false }
                        )
                      }
                      disabled={
                        !canEditField(
                          "alternate_number",
                          props.lead?.alternate_number
                        )
                      }
                    />
                    {indiaOnlyalt ? (
                      <p className="text-normal fst-italic">
                        (Only 10 digits required)
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-3">
                    <label>Country</label>
                    <div
                      className={
                        !canEditField(
                          "country_name",
                          country || props.lead?.country_name
                        )
                          ? "disable-field"
                          : ""
                      }
                    >
                      <Select
                        id="country"
                        name="country"
                        placeholder="Select..."
                        options={updatedCountries}
                        defaultValue={{ label: "India", value: "India" }}
                        onChange={value => {
                          updatedState(value.id),
                            dialCode(value.sortname),
                            setCountry(value.name),
                            setValues(
                              { country: value, state: null, city: null },
                              false
                            )
                        }}
                        isDisabled={
                          !canEditField(
                            "country_name",
                            country || props.lead?.country_name
                          )
                        }
                      />
                    </div>
                  </div>
                </Col>
                <Col md={3}>
                  {loader1 ? (
                    <div className="mb-3 required">
                      <label>State</label> <br />
                      <Spinner />
                    </div>
                  ) : (
                    <div className="mb-3">
                      <label>State</label>
                      <div
                        className={
                          !canEditField("state", props.lead?.state)
                            ? "disable-field"
                            : ""
                        }
                      >
                        <Select
                          id="state"
                          name="state"
                          placeholder="Select..."
                          options={updatedStates}
                          defaultValue={{ label: state }}
                          onChange={value => {
                            setState(value.name), setFieldValue("state", value)
                          }}
                          isDisabled={!canEditField("state", props.lead?.state)}
                        />
                      </div>
                    </div>
                  )}
                </Col>
                <Col md={3}>
                  {loader1 ? (
                    <div className="mb-3">
                      <label>District</label> <br />
                      <Spinner />
                    </div>
                  ) : (
                    <div className="mb-3">
                      <label>District</label>
                      <div
                        className={
                          !canEditField("district", props.lead?.district)
                            ? "disable-field"
                            : ""
                        }
                      >
                        <Select
                          id="city"
                          name="district"
                          placeholder="Select..."
                          options={updatedCities(
                            values.state ? values.state.value : null
                          )}
                          defaultValue={{ label: district }}
                          onChange={value => {
                            setDistrict(value.name),
                              districtExist(value.name),
                              setFieldValue("city", value)
                          }}
                          isDisabled={
                            !canEditField("district", props.lead?.district)
                          }
                        />
                      </div>
                    </div>
                  )}
                </Col>
                <Col md={3}>
                  <div className="mb-3">
                    <AvField
                      label="Pin Code"
                      type="number"
                      onFocus={e =>
                        e.target.addEventListener(
                          "wheel",
                          function (e) {
                            e.preventDefault()
                          },
                          { passive: false }
                        )
                      }
                      max="999999"
                      name="pin_code"
                      placeholder="Enter pin code"
                      onChange={e => getAllStates(e.target.value)}
                      value={props.lead && props.lead.pin_code}
                      className={
                        !canEditField("pin_code", props.lead?.pin_code)
                          ? "disable-field"
                          : ""
                      }
                      disabled={!canEditField("pin_code", props.lead?.pin_code)}
                    />
                    {message ? (
                      <p className="text-danger fst-italic">
                        Pin code Incorrect*
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                </Col>
                <Col md={3}>
                  {loader1 ? (
                    <div className="mb-3">
                      <label>City</label> <br />
                      <Spinner />
                    </div>
                  ) : (
                    <div className="mb-3">
                      <AvField
                        label="City"
                        type="text"
                        name="city"
                        placeholder="Enter city"
                        value={city || (props.lead && props.lead.city) || ""}
                        onChange={e => setCity(e.target.value)}
                        className={
                          !canEditField("city", props.lead?.city)
                            ? "disable-field"
                            : ""
                        }
                        disabled={!canEditField("city", props.lead?.city)}
                      />
                    </div>
                  )}
                </Col>
                {props.lead !== undefined &&
                props.lead?.type.includes("matured") ? (
                  <Col md={3}>
                    <div className="mb-3">
                      <label>Working Area</label>
                      <AvField
                        type="text"
                        name="working_area"
                        value={props.lead && props.lead.working_area}
                        onChange={e => setArea(e.target.value)}
                        className={
                          !canEditField(
                            "working_area",
                            props.lead?.working_area
                          )
                            ? "disable-field"
                            : ""
                        }
                        disabled={
                          !canEditField(
                            "working_area",
                            props.lead?.working_area
                          )
                        }
                      />
                    </div>
                  </Col>
                ) : (
                  ""
                )}
                <Col md={3}>
                  <div className="mb-3">
                    <AvField
                      label="Firm name"
                      type="text"
                      name="firm_name"
                      placeholder="Enter firm name"
                      value={props.lead && props.lead.firm_name}
                      className={
                        !canEditField("firm_name", props.lead?.firm_name)
                          ? "disable-field"
                          : ""
                      }
                      disabled={
                        !canEditField("firm_name", props.lead?.firm_name)
                      }
                    />
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-3">
                    <AvField
                      label="Best Time to Talk"
                      type="time"
                      name="best_time"
                      value={props.lead?.best_time}
                      className={
                        !canEditField("best_time", props.lead?.best_time)
                          ? "disable-field"
                          : ""
                      }
                      disabled={
                        !canEditField("best_time", props.lead?.best_time)
                      }
                    />
                  </div>
                </Col>
                {getCurrentUser().enable_branch === 1 ? (
                  props.lead?.id !== undefined ? (
                    <Col md={3}>
                      <div className="mb-3">
                        <label htmlFor="branch-select" className="form-label">
                          Branch
                        </label>
                        <AvField
                          className={
                            !canEditField("branch", props.lead?.branch?.id)
                              ? "disable-field"
                              : ""
                          }
                          type="select"
                          name="branch"
                          id="branch-select"
                          onChange={handleSelectChanges}
                          disabled={
                            !canEditField("branch", props.lead?.branch?.id)
                          }
                        >
                          <option>Select Branch</option>
                          {branches.map((branch, index) => (
                            <option key={index} value={branch.value}>
                              {branch.label}
                            </option>
                          ))}
                        </AvField>
                      </div>
                    </Col>
                  ) : (
                    <Col md={3}>
                      <div className="mb-3 required">
                        <label htmlFor="branch-select" className="form-label">
                          Branch
                        </label>
                        <div
                          className={
                            !canEditField("branch", props.lead?.branch_id)
                              ? "disable-field"
                              : ""
                          }
                        >
                          <Select
                            id="branch-select"
                            isMulti
                            options={branches}
                            value={branches.filter(branch =>
                              selectedBranches.includes(branch.value)
                            )}
                            onChange={handleSelectChange}
                            placeholder="Select Branch"
                            isDisabled={
                              !canEditField("branch", props.lead?.branch_id)
                            }
                          />
                        </div>
                      </div>
                    </Col>
                  )
                ) : (
                  ""
                )}
                <Col md={3}>
                  {getCurrentUser() &&
                  getCurrentUser().role_name === "Executive" ? (
                    <div className="">
                      <AvField
                        className="select-arrow d-none"
                        type="select"
                        name="leadholder_id"
                        value={getCurrentUser().id}
                      >
                        <option value="" hidden>
                          Select Leadholder
                        </option>
                        {JSON.parse(localStorage.getItem("AllUsers"))?.map(
                          (option, i) => (
                            <option value={option.id} key={i}>
                              {option.name}
                            </option>
                          )
                        )}
                      </AvField>
                    </div>
                  ) : getCurrentUser() &&
                    getCurrentUser().role_name === "Team Leader" ? (
                    <div className="mb-3 required">
                      <AvField
                        className={`select-arrow ${
                          !canEditField(
                            "leadholder_id",
                            props.lead?.leadholder_id
                          )
                            ? "disable-field"
                            : ""
                        }`}
                        label="Lead Holder"
                        type="select"
                        name="leadholder_id"
                        value={props.lead?.leadholder_id || ""}
                        required
                        disabled={
                          !canEditField(
                            "leadholder_id",
                            props.lead?.leadholder_id
                          )
                        }
                      >
                        <option value="" hidden>
                          Select Leadholder
                        </option>
                        {JSON.parse(localStorage.getItem("AllUsers"))?.map(
                          (option, i) => (
                            <option value={option.id} key={i}>
                              {option.name}
                            </option>
                          )
                        )}
                      </AvField>
                    </div>
                  ) : (
                    <div className="mb-3 required">
                      <AvField
                        className={`select-arrow ${
                          !canEditField(
                            "leadholder_id",
                            props.lead?.leadholder_id
                          )
                            ? "disable-field"
                            : ""
                        }`}
                        label="Lead Holder"
                        type="select"
                        name="leadholder_id"
                        value={props.lead?.leadholder_id || ""}
                        required
                        disabled={
                          !canEditField(
                            "leadholder_id",
                            props.lead?.leadholder_id
                          )
                        }
                      >
                        <option value="" hidden>
                          Select Leadholder
                        </option>
                        {selectedBranches.length > 0
                          ? filteredLeadHolders.map((manager, i) => (
                              <option value={manager.id} key={i}>
                                {manager.name}
                              </option>
                            ))
                          : JSON.parse(localStorage.getItem("AllUsers"))?.map(
                              (option, i) => (
                                <option value={option.id} key={i}>
                                  {option.name}
                                </option>
                              )
                            )}
                      </AvField>
                    </div>
                  )}
                </Col>

                <Col md={3}>
                  <div className="mb-3 required2">
                    <AvField
                      className={`select-arrow ${
                        !canEditField(
                          "lead_source_id",
                          props.lead?.lead_source_id
                        )
                          ? "disable-field"
                          : ""
                      }`}
                      label="Lead Source"
                      type="select"
                      name="lead_source_id"
                      value={
                        props.lead && props.lead.lead_source_id !== undefined
                          ? props.lead.lead_source_id
                          : 0
                      }
                      disabled={
                        !canEditField(
                          "lead_source_id",
                          props.lead?.lead_source_id
                        )
                      }
                    >
                      <option value="" hidden>
                        Select Lead Source
                      </option>
                      {JSON.parse(localStorage.getItem("AllSource")) &&
                        JSON.parse(localStorage.getItem("AllSource")).map(
                          (option, i) => (
                            <option value={option.id} key={i}>
                              {option.name}
                            </option>
                          )
                        )}
                    </AvField>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-3 required2">
                    <label>Lead Label</label>
                    <Select
                      isMulti
                      isClearable="true"
                      name="lead_label_id"
                      options={options}
                      value={selectedLabels}
                      onChange={e => getSelectedId(e)}
                    />
                  </div>
                </Col>
                {getCurrentUser() && getCurrentUser().tag == 1 ? (
                  <Col md={3}>
                    <div className="mb-3 required2">
                      <AvField
                        className={`select-arrow ${
                          !canEditField("tag_id", props.lead?.tag_id)
                            ? "disable-field"
                            : ""
                        }`}
                        label="Lead Tags"
                        type="select"
                        name="tag_id"
                        value={props.lead && props.lead.tag_id}
                        disabled={!canEditField("tag_id", props.lead?.tag_id)}
                      >
                        <option value="" hidden>
                          Select Tag
                        </option>
                        {JSON.parse(localStorage.getItem("AllTags")) &&
                          JSON.parse(localStorage.getItem("AllTags")).map(
                            (option, i) => (
                              <option value={option.id} key={i}>
                                {option.name}
                              </option>
                            )
                          )}
                      </AvField>
                    </div>
                  </Col>
                ) : (
                  ""
                )}
                <Col md={3}>
                  <div className="mb-3">
                    <label className="form-group" htmlFor="dob">
                      DOB
                    </label>
                    <DatePicker
                      className={`w-100 form-control ${
                        !canEditField("dob", props.lead?.dob)
                          ? "disable-field"
                          : ""
                      }`}
                      dateFormat="yyyy-MM-dd"
                      id="dob"
                      name="dob"
                      selected={dobDate}
                      onChange={date => setDobDate(date)}
                      disabled={!canEditField("dob", props.lead?.dob)}
                    />
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-3">
                    <label className="form-group" htmlFor="anniversary">
                      Anniversary
                    </label>
                    <DatePicker
                      className={`w-100 form-control ${
                        !canEditField("anniversary", props.lead?.anniversary)
                          ? "disable-field"
                          : ""
                      }`}
                      dateFormat="yyyy-MM-dd"
                      id="anniversary"
                      name="anniversary"
                      selected={anniDate}
                      onChange={date => setAnniDate(date)}
                      disabled={
                        !canEditField("anniversary", props.lead?.anniversary)
                      }
                    />
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-3">
                    <label className="form-group" htmlFor="important_date">
                      Important Date
                    </label>
                    <DatePicker
                      className={`w-100 form-control ${
                        !canEditField(
                          "important_date",
                          props.lead?.important_date
                        )
                          ? "disable-field"
                          : ""
                      }`}
                      dateFormat="yyyy-MM-dd"
                      id="important_date"
                      name="important_date"
                      selected={importantDate}
                      onChange={date => setImportantDate(date)}
                      disabled={
                        !canEditField(
                          "important_date",
                          props.lead?.important_date
                        )
                      }
                    />
                  </div>
                </Col>
                {getCurrentUser()?.crmpro_permission === 1 ||
                getCurrentUser()?.crmpronew_permission === 1 ? (
                  <>
                    <Col md={3}>
                      <div className="mb-3">
                        <label>Proforma Invoice(bill to)</label>
                        <ReactQuill
                          className={
                            !canEditField(
                              "proforma_address",
                              props.lead?.proforma_address
                            )
                              ? "disable-field"
                              : ""
                          }
                          theme="snow"
                          value={proformaValue}
                          onChange={e => setProformaValue(e)}
                          readOnly={
                            !canEditField(
                              "proforma_address",
                              props.lead?.proforma_address
                            )
                          }
                        />
                      </div>
                    </Col>
                    <Col md={3}>
                      <div className="mb-3">
                        <label>Shipping address</label>
                        <ReactQuill
                          className={
                            !canEditField("deliver_to", props.lead?.deliver_to)
                              ? "disable-field"
                              : ""
                          }
                          theme="snow"
                          value={deliverTo}
                          onChange={e => setDeliverTo(e)}
                          readOnly={
                            !canEditField("deliver_to", props.lead?.deliver_to)
                          }
                        />
                      </div>
                    </Col>
                  </>
                ) : (
                  ""
                )}
                {props.lead !== undefined ? (
                  ""
                ) : (
                  <>
                    <Col md={3}>
                      <div className="mb-3">
                        <AvField
                          label="Notes"
                          type="textarea"
                          name="message"
                          placeholder="Enter notes"
                          value={"New lead added."}
                        />
                      </div>
                    </Col>
                  </>
                )}
                {props.lead !== undefined &&
                props.lead?.type.includes("matured") ? (
                  <Col md={3}>
                    <div className="mb-3">
                      <AvField
                        className={
                          !canEditField(
                            "monthly_target",
                            props.lead?.monthly_target
                          )
                            ? "disable-field"
                            : ""
                        }
                        label="Monthly Target"
                        type="number"
                        onFocus={e =>
                          e.target.addEventListener(
                            "wheel",
                            function (e) {
                              e.preventDefault()
                            },
                            { passive: false }
                          )
                        }
                        name="monthly_target"
                        value={props.lead && props.lead.monthly_target}
                        disabled={
                          !canEditField(
                            "monthly_target",
                            props.lead?.monthly_target
                          )
                        }
                      />
                    </div>
                  </Col>
                ) : (
                  ""
                )}
                <Col md={3}>
                  <div className="mb-3">
                    <label>Star</label>
                    <AvField
                      checked={props.lead?.flag == "1" ? true : false}
                      type="checkbox"
                      name="flag"
                    />
                  </div>
                </Col>
                {props.lead !== undefined ? (
                  ""
                ) : (
                  <>
                    <Col md={3}>
                      <div className="mb-3">
                        <label>Send Email</label>
                        <AvField
                          type="checkbox"
                          name="send_email"
                          style={{
                            background: `${
                              getCurrentUser()?.email_enabled === 1
                                ? ""
                                : "lightgray"
                            }`,
                          }}
                          disabled={
                            getCurrentUser()?.email_enabled === 1 ? false : true
                          }
                        />
                      </div>
                    </Col>
                    <Col md={3}>
                      <div className="mb-3">
                        <label>Send Whatsapp</label>
                        <AvField
                          type="checkbox"
                          name="whatsapp"
                          style={{
                            background: `${
                              getCurrentUser()?.whatsapp_enabled === 1
                                ? ""
                                : "lightgray"
                            }`,
                          }}
                          disabled={
                            getCurrentUser()?.whatsapp_enabled === 1
                              ? false
                              : true
                          }
                        />
                      </div>
                    </Col>
                  </>
                )}
                {allFields.length > 0 ? (
                  <>
                    {allFields &&
                      allFields.map((item, i) => (
                        <Col md={3} className="mb-3" key={i}>
                          {item.type === "Input" ? (
                            <div
                              className={`${
                                item.is_required === 1 ? "required" : ""
                              }`}
                            >
                              <AvField
                                className={
                                  !canEditField(
                                    `custom_field_${item.id}`,
                                    item.value
                                  )
                                    ? "disable-field"
                                    : ""
                                }
                                label={item.label}
                                type="text"
                                name={"fieldvalues-" + item.id}
                                placeholder="Enter"
                                onChange={e => setAllFieldValues(e, item.id)}
                                value={item.value}
                                required={item.is_required === 1 ? true : false}
                                disabled={
                                  !canEditField(
                                    `custom_field_${item.id}`,
                                    item.value
                                  )
                                }
                              />
                            </div>
                          ) : (
                            ""
                          )}
                          {item.type === "Dropdown" ? (
                            <div
                              className={`${
                                item.is_required === 1 ? "required" : ""
                              }`}
                            >
                              <AvField
                                className={`select-arrow ${
                                  !canEditField(
                                    `custom_field_${item.id}`,
                                    item.value
                                  )
                                    ? "disable-field"
                                    : ""
                                }`}
                                label={item.label}
                                type="select"
                                name={"fieldvalues-" + item.id}
                                onChange={e => setAllFieldValues(e, item.id)}
                                required={item.is_required === 1 ? true : false}
                                value={item.value}
                                disabled={
                                  !canEditField(
                                    `custom_field_${item.id}`,
                                    item.value
                                  )
                                }
                              >
                                <option value="" hidden>
                                  Select
                                </option>
                                {item.fieldvalues.map((option, i) => (
                                  <option value={option.id} key={i}>
                                    {option.value}
                                  </option>
                                ))}
                              </AvField>
                            </div>
                          ) : (
                            ""
                          )}
                          {item.type === "Radio" ? (
                            <>
                              <div
                                className={`${
                                  item.is_required === 1 ? "required" : ""
                                }`}
                              >
                                <label>{item.label}</label>
                              </div>
                              <AvRadioGroup
                                inline
                                onClick={e => setAllFieldValues(e, item.id)}
                                name={"fieldvalues-" + item.id}
                                defaultValue={item.value}
                                required={item.is_required === 1 ? true : false}
                                className={
                                  !canEditField(
                                    `custom_field_${item.id}`,
                                    item.value
                                  )
                                    ? "disable-field"
                                    : ""
                                }
                              >
                                {item.fieldvalues.map((radio, i) => (
                                  <AvRadio
                                    key={i}
                                    label={radio.value}
                                    value={radio.id.toString()}
                                    disabled={
                                      !canEditField(
                                        `custom_field_${item.id}`,
                                        item.value
                                      )
                                    }
                                  />
                                ))}
                              </AvRadioGroup>
                            </>
                          ) : (
                            ""
                          )}
                          {item.type === "Checkbox" ? (
                            <div>
                              <label>{item.label}</label>
                              <AvCheckboxGroup
                                inline
                                onClick={e => setAllFieldValues(e, item.id)}
                                name={"fieldvalues-" + item.id}
                                value={
                                  item.value !== null
                                    ? item.value.split(",")
                                    : []
                                }
                                className={
                                  !canEditField(
                                    `custom_field_${item.id}`,
                                    item.value
                                  )
                                    ? "disable-field"
                                    : ""
                                }
                              >
                                {item.fieldvalues.map((check, i) => (
                                  <AvCheckbox
                                    key={i}
                                    label={check.value}
                                    value={check.id.toString()}
                                    disabled={
                                      !canEditField(
                                        `custom_field_${item.id}`,
                                        item.value
                                      )
                                    }
                                  />
                                ))}
                              </AvCheckboxGroup>
                            </div>
                          ) : (
                            ""
                          )}
                          {item.type === "Text Area" ? (
                            <div
                              className={`${
                                item.is_required === 1 ? "required" : ""
                              }`}
                            >
                              <AvField
                                className={
                                  !canEditField(
                                    `custom_field_${item.id}`,
                                    item.value
                                  )
                                    ? "disable-field"
                                    : ""
                                }
                                label={item.label}
                                type="textarea"
                                name={"fieldvalues-" + item.id}
                                placeholder="Enter"
                                value={item.value}
                                onChange={e => setAllFieldValues(e, item.id)}
                                required={item.is_required === 1 ? true : false}
                                disabled={
                                  !canEditField(
                                    `custom_field_${item.id}`,
                                    item.value
                                  )
                                }
                              />
                            </div>
                          ) : (
                            ""
                          )}
                          {item.type === "Flip Button" ? (
                            <>
                              <div className="mb-3">
                                <label>
                                  <span>{item.label}</span>
                                  <br />
                                  <div className="form-check form-switch">
                                    <input
                                      className={`form-check-input ${
                                        !canEditField(
                                          `custom_field_${item.id}`,
                                          item.value
                                        )
                                          ? "disable-field"
                                          : ""
                                      }`}
                                      type="checkbox"
                                      role="switch"
                                      id="flexSwitchCheckDefault"
                                      name={"fieldvalues-" + item.id}
                                      onChange={e =>
                                        setAllFieldValues(e, item.id)
                                      }
                                      defaultChecked={
                                        item.value == "on" ? true : false
                                      }
                                      disabled={
                                        !canEditField(
                                          `custom_field_${item.id}`,
                                          item.value
                                        )
                                      }
                                    />
                                  </div>
                                </label>
                              </div>
                            </>
                          ) : (
                            ""
                          )}
                        </Col>
                      ))}
                  </>
                ) : (
                  ""
                )}
              </Row>
            </div>
            <div className="modal-footer">
              <div className="text-end">
                {loading ? (
                  <button
                    className="btn btn-primary disabled"
                    type="button"
                    disabled
                  >
                    Loading
                  </button>
                ) : (
                  <>
                    {props.lead !== undefined ? (
                      <>
                        {duplicate2 == 0 && duplicate3 == 0 ? (
                          <button
                            className="btn btn-primary"
                            type="submit"
                            disabled
                          >
                            Submit
                          </button>
                        ) : (
                          <button className="btn btn-primary" type="submit">
                            Submit
                          </button>
                        )}
                      </>
                    ) : (
                      <>
                        {duplicate2 == 1 && duplicate3 == 1 ? (
                          <button className="btn btn-primary" type="submit">
                            Create
                          </button>
                        ) : (
                          <button
                            className="btn btn-primary"
                            type="submit"
                            disabled
                          >
                            Create
                          </button>
                        )}
                      </>
                    )}
                  </>
                )}
              </div>
            </div>
          </AvForm>
        </Modal>
      )}
    </>
  )
}
